import { Heading } from '@chakra-ui/react';
import Link from 'next/link';
import React, { ReactElement,  } from 'react';

import { maxTablet } from '@/constants/vars.constants';
import { useRoutesConfig } from '@/hooks/routes-config';
import { useWindowSize } from '@/hooks/window-size.hook';
import { SpecialsReq } from '@/types/request/request.types';
import {  VehicleType } from '@/types/used-cars/used-cars.types';

import { BlockWrapper } from '../block-wrapper/block-wrapper';
import { LinkButton } from '../buttons/link-button/link-button';
import { CarSlider } from '../details-car/car-slider/car-slider';
import { DealItem } from '../specials-category/deal-item/deal-item';

import styles from './car-specials.module.scss';

export const CarSpecials: React.FC<{
  specials: SpecialsReq[];
  description: string;
  descriptionDemo: string;
  carType: VehicleType;
}> = ({ specials, description, descriptionDemo, carType }) => {
  const routes = useRoutesConfig();
  const { width } = useWindowSize();
  const isTablet = width ? width <= maxTablet : false;
  const currentSpecials = specials;
  const specialVehicles = currentSpecials?.map((special, index) => (
    <DealItem key={index} dealInfo={special} />
  ));

  const getHeaderForSpecialSection = (
    activeCarType: string,
  ): string | ReactElement => {
    switch (activeCarType) {
      case VehicleType.Demo:
        return 'Demo Used Car Specials';
      default:
        return (
          <a className={styles.a_link} href={routes.specials.path}>
            Used Car Promotions
          </a>
        );
    }
  };

  const getDescriptionForSpecialSection = (
    activeCarType: string,
  ): ReactElement => {
    const getDescription = (description: string) => {
      return (
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>
      );
    };

    switch (activeCarType) {
      case VehicleType.Demo:
        return getDescription(descriptionDemo);
      default:
        return getDescription(description);
    }
  };

  if (!specialVehicles || !specialVehicles.length) {
    return;
  }
  return (
    <div className={styles.wrapper}>
      <BlockWrapper>
        <div className={styles.sectionWrapper}>
          <div className={styles.titleWrap}>
            <Heading className={styles.title} fontFamily="KiaSignature" as="h2">
              {carType && getHeaderForSpecialSection(carType)}
            </Heading>
            {isTablet ? (
              <Link href={routes.specials.path} className={styles.tabletLink} prefetch={false}>
                View All
              </Link>
            ) : null}
          </div>
          <div className={styles.specialsDescription}>
            {carType && getDescriptionForSpecialSection(carType)}
            {!isTablet ? (
              <div className="mt-2">
                <LinkButton
                  label="View All Kia Promotions"
                  link={routes.specials.path}
                />
              </div>
            ) : null}
          </div>
          {specialVehicles.length > 0 ? (
            <CarSlider
              vehiclesAsComponents={specialVehicles}
              infinite={false}
              hasNav={specialVehicles.length > 3}
            />
          ) : (
            <p className={styles.notAvailable}>
              Currently there are no promotions available
            </p>
          )}
        </div>
      </BlockWrapper>
    </div>
  );
};
